<template>
    <div class="chat_main scroll_bar">
        <div class="history_message">
            <p @click="getHistory" v-if="!loadStatus">{{ $t('historyChat') }}</p>
            <p v-if="loadStatus === 'loading'">{{ $t('loading') }}</p>
            <p v-if="loadStatus === 'end'">{{ $t('noHistory') }}</p>
        </div>
        <div class="message_item" v-for="item in chatList" :key="item.date">
            <!--            机器人 或者  人工客服-->
            <div
                v-if="
          (item.senderType === 2 || item.senderType === 3) &&
          !item.sensitiveFlag &&
          !item.sensitiveWords &&
          !item.recallFlag
        "
                class="left_message"
            >
                <div class="face" v-if="initData.avatar">
                    <img :src="item.faceUrl"/>
                </div>
                <div class="message">
                    <div class="send_name">{{ item.senderName }} {{ formDate(item.msgTime, 'MM-dd hh:mm:ss') }}</div>
                    <!--  这里会有各种消息类型 -->
                    <div
                        v-if="
              (item.msgType === 1 || !item.msgType) && item.docPattern !== 1
            "
                        class="text_message"
                    >
                        <div v-html="item.msgContent"></div>
                        <div v-html="item.answer"></div>
                        <div
                            class="guide"
                            :style="{ color: initData.kitBgcolor }"
                            @click="guideSend(guide)"
                            v-for="(guide, $index) in item.suggestList"
                            v-html="$index + 1 + '.' + guide.question"
                        ></div>
                    </div>
                    <!--  多轮问题展示 -->
                    <div
                        v-if="
              (item.msgType === 1 || item.msgType === 3 || !item.msgType) &&
              item.docPattern === 1
            "
                        class="text_message"
                    >
                        <div
                            v-if="
                (item.docNode && item.docNode.nodeType !== 3) || !item.docNode
              "
                            v-html="item.answer"
                        ></div>
                        <div v-if="item.docNode.nodeType === 3">
                            <Iframe :src="item.docNode.nodeContent"></Iframe>
                        </div>
                        <div
                            class="guide series"
                            @click="seriesProblem(guide)"
                            v-for="(guide, $index) in item.docNode.itemList"
                            v-html="guide.itemContent"
                        ></div>
                    </div>
                    <div v-if="item.msgType === 2" class="image_message">
                        <img
                            :src="item.msgContent"
                            :alt="item.fileName"
                            @click="showLargeImage(item)"
                        />
                    </div>
                    <!--          机器人富文本-->
                    <div
                        v-if="
              item.msgType === 3 &&
              item.senderType === 3 &&
              item.docPattern !== 1
            "
                        class="text_message"
                    >
                        <div v-html="item.msgContent"></div>
                        <div
                            class="guide"
                            :style="{ color: initData.kitBgcolor }"
                            v-for="(guide, $index) in JSON.parse(item.robotSuggest)"
                            @click="guideSend(guide)"
                            v-html="$index + 1 + '.' + guide.question"
                        ></div>
                    </div>
                    <!--              人工富文本-->
                    <div
                        v-if="
              item.msgType === 3 &&
              item.senderType === 2 &&
              item.docPattern !== 1
            "
                        class="card_message"
                    >
                        <img :src="JSON.parse(item.msgContent).picture"/>
                        <div class="info">
                            <div class="title">{{ JSON.parse(item.msgContent).title }}</div>
                            <div class="desc">{{ JSON.parse(item.msgContent).desc }}</div>
                            <div class="price">{{ JSON.parse(item.msgContent).price }}</div>
                        </div>
                    </div>
                    <div v-if="item.msgType === 4" class="file_message">
                        <div class="file_icon">
                            <svg
                                t="1617682401274"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="2051"
                                width="32"
                                height="32"
                            >
                                <path
                                    d="M597.333333 85.333333H256c-46.933333 0-84.906667 38.4-84.906667 85.333334L170.666667 853.333333c0 46.933333 37.973333 85.333333 84.906666 85.333334H768c46.933333 0 85.333333-38.4 85.333333-85.333334V341.333333l-256-256z m85.333334 682.666667H341.333333v-85.333333h341.333334v85.333333z m0-170.666667H341.333333v-85.333333h341.333334v85.333333z m-128-213.333333V149.333333L789.333333 384H554.666667z"
                                    fill="#bfbfbf"
                                    p-id="2052"
                                ></path>
                            </svg>
                        </div>
                        <div class="file_name">
                            <div>{{ item.fileName }}</div>
                            <div class="file_size">
                                <span v-if="item.size">{{ item.size }}k</span>
                                <a @click.prevent="newTab(item)">{{ $t('download') }}</a>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.msgType === 5" class="audio_message">
                        <audio :src="item.msgContent" controls></audio>
                    </div>
                    <div v-if="item.msgType === 6" class="video_message">
                        <video :src="item.msgContent" controls></video>
                    </div>
                    <div v-if="item.msgType === 7" class="goods_message">
                        <div class="goods_info">
                            <div class="goods_image">
                                <img :src="JSON.parse(item.msgContent).imgUrl" alt=""/>
                            </div>
                            <div class="goods_detail">
                                <div class="goods_title">
                                    {{ JSON.parse(item.msgContent).title }}
                                </div>
                                <div class="goods_desc">
                                    {{ JSON.parse(item.msgContent).describe }}
                                </div>
                                <div class="goods_label">
                                    {{ JSON.parse(item.msgContent).label }}
                                </div>
                            </div>
                        </div>
                        <div class="goods_action">
                            <a target="_blank" :href="JSON.parse(item.msgContent).fromUrl"
                            >{{ $t('showDetail') }}</a
                            >
                        </div>
                    </div>
                    <div v-if="item.msgType === 8" class="order_message">
                        <div class="goods_info">
                            <div class="goods_image">
                                <img :src="JSON.parse(item.msgContent).imgUrl" alt=""/>
                            </div>
                            <div class="goods_detail">
                                <div class="goods_title">
                                    {{ JSON.parse(item.msgContent).title }}
                                </div>
                                <div class="goods_desc">
                                    {{ JSON.parse(item.msgContent).describe }}
                                </div>
                            </div>
                        </div>
                        <div class="order_data">
                            <div>
                                {{ $t('orderStatus') }}：<span>{{
                                    JSON.parse(item.msgContent).orderStatus
                                }}</span>
                            </div>
                            <div>
                                {{ $t('orderNumber') }}：<span>{{
                                    JSON.parse(item.msgContent).orderCode
                                }}</span>
                            </div>
                            <div>
                                {{ $t('orderTime') }} ：<span>{{
                                    JSON.parse(item.msgContent).orderTime
                                }}</span>
                            </div>
                        </div>
                        <div class="goods_action">
                            <a target="_blank" :href="JSON.parse(item.msgContent).fromUrl"
                            > {{ $t('showDetail') }}</a
                            >
                        </div>
                    </div>
                    <div v-if="false">
                        <span>{{ $t('thump') }}</span>
                        <span>{{ $t('top') }}</span>
                    </div>
                </div>
            </div>
            <!--            用户-->
            <div v-if="item.senderType === 1" class="right_message">
                <div v-if="false" class="face">
                    <img :src="item.faceUrl"/>
                </div>
                <div class="message">
                    <div class="send_name"> {{ formDate(item.msgTime, 'MM-dd hh:mm:ss') }}</div>
                    <!--                    {{ item.name || item.senderName }}-->
                    <!--  这里会有各种消息类型              -->
                    <div
                        :style="{
              backgroundColor: initData.kitBgcolor,
              color: initData.kitTxcolor,
            }"
                        v-if="item.msgType === 1"
                        class="text_message"
                        v-html="item.msgContent"
                    ></div>
                    <div v-if="item.msgType === 2" class="image_message">
                        <img
                            :src="item.msgContent"
                            :alt="item.name"
                            @click="showLargeImage(item)"
                        />
                    </div>
                    <div v-if="item.msgType === 3" class="card_message">
                        <img :src="JSON.parse(item.msgContent).picture"/>
                        <div class="info">
                            <div class="title">{{ JSON.parse(item.msgContent).title }}</div>
                            <div class="desc">{{ JSON.parse(item.msgContent).desc }}</div>
                            <div class="price">{{ JSON.parse(item.msgContent).price }}</div>
                        </div>
                    </div>
                    <div v-if="item.msgType===9" class="card_message card_order"
                         :style="{backgroundColor:initData.kitBgcolor,color:initData.kitTxcolor}">
                        <div class="info">
<!--                            <span :style="{color:initData.kitTxcolor}">{{ item.msgContent }}</span>-->
                            <div :style="{color:initData.kitTxcolor}" class="desc" v-for="(key,value) in JSON.parse(item.msgContent)" v-if="key&&value">
                                {{ value }}:{{key}}
                            </div>
<!--                            <div :style="{color:initData.kitTxcolor}" class="desc">-->
<!--                                充值方式:{{ JSON.parse(item.msgContent).type }}-->
<!--                            </div>-->
<!--                            <div :style="{color:initData.kitTxcolor}" class="desc">-->
<!--                                充值金额:{{ JSON.parse(item.msgContent).price }}-->
<!--                            </div>-->
<!--                            <div :style="{color:initData.kitTxcolor}" class="desc">-->
<!--                                订单状态:{{ JSON.parse(item.msgContent).status }}-->
<!--                            </div>-->
<!--                            <div :style="{color:initData.kitTxcolor}" class="desc">-->
<!--                                充值账号:{{ JSON.parse(item.msgContent).account }}-->
<!--                            </div>-->
<!--                            <div :style="{color:initData.kitTxcolor}" class="desc">-->
<!--                                创建时间:{{ JSON.parse(item.msgContent).time }}-->
<!--                            </div>-->
                        </div>
                    </div>
                    <div v-if="item.msgType === 4" class="file_message">
                        <div class="file_icon">
                            <svg
                                t="1617682401274"
                                class="icon"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                p-id="2051"
                                width="32"
                                height="32"
                            >
                                <path
                                    d="M597.333333 85.333333H256c-46.933333 0-84.906667 38.4-84.906667 85.333334L170.666667 853.333333c0 46.933333 37.973333 85.333333 84.906666 85.333334H768c46.933333 0 85.333333-38.4 85.333333-85.333334V341.333333l-256-256z m85.333334 682.666667H341.333333v-85.333333h341.333334v85.333333z m0-170.666667H341.333333v-85.333333h341.333334v85.333333z m-128-213.333333V149.333333L789.333333 384H554.666667z"
                                    fill="#bfbfbf"
                                    p-id="2052"
                                ></path>
                            </svg>
                        </div>
                        <div class="file_name">
                            <div>{{ item.fileName }}</div>
                            <div class="file_size">
                                <span v-if="item.size">{{ item.size }}k</span>
                                <a @click.prevent="newTab(item)">{{ $t('download') }}</a>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.msgType === 5" class="audio_message">
                        <audio :src="item.msgContent" controls></audio>
                    </div>
                    <div v-if="item.msgType === 6" class="video_message">
                        <video :src="item.msgContent" controls></video>
                    </div>
                    <div v-if="item.msgType === 7" class="goods_message">
                        <div class="goods_info">
                            <div class="goods_image">
                                <img :src="JSON.parse(item.msgContent).imgUrl" alt=""/>
                            </div>
                            <div class="goods_detail">
                                <div class="goods_title">
                                    {{ JSON.parse(item.msgContent).title }}
                                </div>
                                <div class="goods_desc">
                                    {{ JSON.parse(item.msgContent).describe }}
                                </div>
                                <div class="goods_label">
                                    {{ JSON.parse(item.msgContent).label }}
                                </div>
                            </div>
                        </div>
                        <div class="goods_action">
                            <a target="_blank" :href="JSON.parse(item.msgContent).fromUrl">{{ $t('showDetail') }}</a>
                        </div>
                    </div>
                    <div v-if="item.msgType === 8" class="order_message">
                        <div class="goods_info">
                            <div class="goods_image">
                                <img :src="JSON.parse(item.msgContent).imgUrl" alt=""/>
                            </div>
                            <div class="goods_detail">
                                <div class="goods_title">
                                    {{ JSON.parse(item.msgContent).title }}
                                </div>
                                <div class="goods_desc">
                                    {{ JSON.parse(item.msgContent).describe }}
                                </div>
                            </div>
                        </div>
                        <div class="order_data">
                            <div>
                                {{ $t('orderStatus') }}：<span>{{
                                    JSON.parse(item.msgContent).orderStatus
                                }}</span>
                            </div>
                            <div>
                                {{ $t('orderNumber') }}：<span>{{
                                    JSON.parse(item.msgContent).orderCode
                                }}</span>
                            </div>
                            <div>
                                {{ $t('orderTime') }}：<span>{{
                                    JSON.parse(item.msgContent).orderTime
                                }}</span>
                            </div>
                        </div>
                        <div class="goods_action">
                            <a target="_blank" :href="JSON.parse(item.msgContent).fromUrl"
                            >{{ $t('showDetail') }}</a
                            >
                        </div>
                    </div>
                    <i
                        v-if="item.status === 'loading'"
                        class="el-icon-loading status"
                    ></i>
                    <i v-if="item.status === 'failed'" class="el-icon-warning status"></i>
                </div>
            </div>
            <!--            系统消息-->
            <div v-if="item.senderType === 4" class="system_message">
                <span :class="item.type === 1 ? 'normal' : 'bg'" v-html="item.msgContent"></span>
            </div>
        </div>
        <span
            v-scroll-bottom="scrollBottom"
            class="scroll_auto scroll-bottom scroll_iframe_auto_bottom"
        ></span>
        <el-drawer
            direction="rtl"
            ref="groupDrawer"
            :with-header="true"
            :modal="false"
            :size="'240px'"
            :visible.sync="showGroup"
            :show-close="showCloseBtn"
            :before-close="beforeClose"
        >
            <div class="group_border" v-if="!showFormChat">
                <div
                    class="group_item"
                    @mouseenter="setColor"
                    @mouseleave="resetColor"
                    :style="{ border: `1px solid ${initData.kitBgcolor}`,color:initData.kitBgcolor }"
                    v-for="group in channelGroup"
                    :key="group.id"
                    @click="selectGroup(group)"
                >
                    {{ group.groupName }}
                </div>
            </div>
            <div class="form_user" v-if="showFormChat">
                <p>{{ initData.userForm.formTitle }}</p>
                <div v-for="item in formData.formList" v-if="item.show">
                    <span class="label"> <span class="red" v-if="item.require">*</span>{{ item.name }}</span>
                    <el-input :maxLength="16" v-model="item.value" type="text" :placholder="$t('input')"/>
                </div>
                <el-button @click="submitForm" :style="{backgroundColor:initData.kitBgcolor}" type="default"
                           size="normal">
                    {{ $t('submit') }}
                </el-button>
            </div>

        </el-drawer>
        <el-drawer
            size="100%"
            :append-to-body="true"
            :with-header="false"
            direction="ttb"
            :visible.sync="showImage"
        >
            <div class="img_border" @click="showImage = !showImage">
                <img :src="largeImageUrl" class="largeImage"/>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import chatApi from "../methods";
import store from "../../store";
import {Toast} from "mint-ui";

export default {
    name: "chatpc",
    data() {
        return {
            showImage: false,
            largeImageUrl: "",
            showGroup: false,
            showCloseBtn: false,
            formData: {}
        };
    },
    computed: {
        showFormChat() {
            return this.$store.state.showFormChat;
        },
        chatList() {
            return this.$store.state.chatList;
        },
        scrollBottom() {
            return this.$store.state.scrollBottom;
        },
        loadStatus() {
            return this.$store.state.loadStatus;
        },
        showChannelGroup() {
            this.showGroup = this.$store.state.showChannelGroup;
        },
        channelGroup() {
            return this.$store.state.channelGroup;
        },
        initData() {
            try {
                if (this.$store.state.initData.userForm) {
                    this.formData = JSON.parse(JSON.stringify(this.$store.state.initData.userForm));
                }
            } catch (e) {
            }
            return this.$store.state.initData;
        },
        connectStatus() {
            return this.$store.state.connectStatus;
        },
    },
    watch: {
        chatList() {
            if (this.$store.state.userInfo.status === 0) {
                //未建立会议
                console.log('chat session not yet')
            }
        },
        scrollBottom() {
            setTimeout(() => {
                document.getElementsByClassName("scroll-bottom")[0].scrollIntoView();
            }, 100);
        },
        loadStatus() {
            return this.$store.state.loadStatus;
        },
        showChannelGroup() {
            return this.$store.state.showChannelGroup;
        },
        channelGroup() {
            return this.$store.state.channelGroup;
        },

        showGroup() {
            if (this.initData.receiveMode == 3) {
                this.showCloseBtn = false;
            } else {
                this.showCloseBtn = true;
            }
            if (!this.showGroup) {
                //receiveMode
                this.$store.dispatch("setShowChannelGroup", false);
            }
        },
    },
    methods: {
        formDate(value, fmt) {
            if (!value) {
                return ''
            }
            fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
            if (value && value < 10000000000) {
                value = value * 1000;
            }

            let getDate = new Date(value * 1);
            let o = {
                'M+': getDate.getMonth() + 1,
                'd+': getDate.getDate(),
                'h+': getDate.getHours(),
                'm+': getDate.getMinutes(),
                's+': getDate.getSeconds(),
                'q+': Math.floor((getDate.getMonth() + 3) / 3),
                'S': getDate.getMilliseconds()
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            for (let k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
                }
            }
            return fmt;
        },
        submitForm() {
            for (let i = 0; i < this.formData.formList.length; i++) {
                if (this.formData.formList[i].require && this.formData.formList[i].show && !this.formData.formList[i].value) {
                    Toast({
                        message: this.$t('pleInput') + `${this.formData.formList[i].name}` + this.$t('content'),
                        duration: 3000
                    });
                    return
                }
            }
            let phoneFormat = /^1[0-9]{10}$/;
            if (this.formData.formList[1].value && !phoneFormat.test(this.formData.formList[1].value)) {
                Toast({
                    message: this.$t('rightPhone'),
                    duration: 3000
                });
                return
            }
            let formatEmail = /^[a-zA-Z0-9]+([-_\.][a-zA-Z0-9]+)*(?:@(?!-))(?:(?:[a-zA-Z0-9-]*)(?:[a-zA-Z0-9](?!-))(?:\.(?!-)))+[a-zA-Z]{2,}$/
            if (this.formData.formList[2].value && !formatEmail.test(this.formData.formList[2].value)) {
                Toast({
                    message: this.$t('rightEmail'),
                    duration: 3000
                });
                return
            }
            let data = {
                userName: this.formData.formList[0].value,
                phone: this.formData.formList[1].value,
                email: this.formData.formList[2].value,
            }
            chatApi.submitUserForm(data)
        },

        setColor(e) {
            e.target.style.backgroundColor = this.initData.kitBgcolor;
            e.target.style.color = "white";
        },
        resetColor(e) {
            e.target.style.backgroundColor = "";
            e.target.style.color = this.initData.kitBgcolor;
        },
        // 图片点击放大
        showLargeImage(img) {
            if (img.msgContent) {
                this.showImage = true;
                this.largeImageUrl = img.msgContent;
            }
        },
        // 历史记录
        getHistory() {
            console.log('111')
            store.dispatch("setLoadingStatus", "loadStart");
            const param = {
                pageSize: 20,
                maxTime: 0,
            };
            chatApi.getHistoryList(param);
        },
        // 点击引导问题
        guideSend(guide) {
            const obj = {
                docId: guide.docId,
                click: 1,
                msgContent: guide.question,
                senderType: 1, // 发送人 1用户，2客服，3机器人
                date: new Date().getTime(),
                msgType: 1, // 消息类型 1文本
                status: "loading", // 消息状态 成功后隐藏否则一直loading
                id: "message" + new Date().getTime(),
            };
            // 更新聊天消息
            this.$store.dispatch("setChatList", obj);
            chatApi.sendMessage(obj);
        },
        // 点击多轮问题
        seriesProblem(guide) {
            const obj = {
                docId: guide.docId,
                itemId: guide.itemId,
                click: 1,
                msgContent: guide.itemContent,
                senderType: 1, // 发送人 1用户，2客服，3机器人
                date: new Date().getTime(),
                msgType: 1, // 消息类型 1文本
                status: "loading", // 消息状态 成功后隐藏否则一直loading
                id: "message" + new Date().getTime(),
            };
            // 更新聊天消息
            this.$store.dispatch("setChatList", obj);
            chatApi.sendMessage(obj);
        },
        // 点击技能组
        selectGroup(group) {
            this.$store.dispatch("setShowChannelGroup", false);
            chatApi.transfer(group);
        },
        newTab(msg) {
            const a = document.createElement("a");
            a.href = msg.msgContent;
            a.download = msg.fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        beforeClose(done) {
            if (this.initData.receiveMode !== 3) {
                done();
            }
        },
    },
    directives: {
        // 发送消息后滚动到底部
        "scroll-bottom"(el) {
            setTimeout(() => {
                // el.scrollIntoView();
            }, 100);
        },
    },
    mounted() {
        setTimeout(() => {
            try {
                document.querySelector(".message_item").onclick = function (e) {
                    const link = e.target.getAttribute("data-link");
                    if (link) {
                        window.open(link);
                    }
                };

            } catch (e) {
            }
        }, 400)


    }
};
</script>

<style scoped>
.form_user button {
    color: #ffffff;
    font-size: 14px;
    width: 100%;
}

.form_user {
    margin: 15px 20px;
    font-size: 14px;
}

.form_user div .label {
    display: block;
    padding-left: 5px;
    width: 60px;
    text-align: left;
    color: #747070
}

.form_user div input {
    display: inline-block;
    width: 70%;
    height: 35px;
    outline: none;
    color: #565656;
    border-radius: 3px;
    padding: 3px;
}

.form_user div {
    margin: 0px auto 6px;
}

.form_user p {
    margin: 15px 5px 25px;
    font-size: 14px;
    text-align: left;
    color: #6f6f6f;
}

.history_message p {
    color: #999999;
    cursor: pointer;
    margin: 4px;
}

.chat_main {
    height: 415px;
    border-top: 0.5px solid #e6e6e6;
    margin-top: 30px;
}

.message {
    position: relative;
    max-width: 100%;
    word-break: break-word;
}

.guide {
    line-height: 30px;
    cursor: pointer;
}

.series {
    display: inline-block;
    padding: 0px 15px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    margin: 5px;
    overflow: hidden;
    max-width: 130px;
    height: 30px;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #7467f0;
    background-color: white;
}

.series:hover {
    background: #f3f3f3;
    color: #596788;
}

.message > div {
    border-radius: 0 10px 10px 10px;
    padding: 10px 15px 8px;
    display: inline-block;
}

.right_message .message > div {
    border-radius: 10px 0 10px 10px;
}

.right_message .text_message {
    border-radius: 10px 0 10px 10px;
}

.right_message .text_message a {
    color: white;
}

.message .status {
    font-size: 16px;
    bottom: 0;
    color: #999;
}

.message .el-icon-warning {
    color: red;
}

.message .send_name {
    padding: 3px 5px;
    display: block;
}

.image_message {
    border: 1px solid #cbcbcb;
}

.image_message img {
    width: auto;
    max-width: 200px;
}

.file_message {
    display: flex;
    background: #f6f6f6;
    border: 1px solid #dcdcdc;
}

.audio_message {
    border: 1px solid #dcdcdc;
}

.file_name {
    text-align: left;
    /*background-image: url("../../../static/image/icon_ui.png");*/
}

.file_size {
    position: relative;
}

.file_size a {
    color: #7063ed;
    text-decoration: none;
    position: absolute;
    right: 4px;
}

.card_message {
    border: 1px solid #e6e6e6;
    padding: 15px;
    cursor: pointer;
}

.card_order {
    text-align: left;
    padding: 10px;
    background: #7467F0;
    width: 180px;
}

.card_order .info .desc {
    height: 20px;
    line-height: 20px;
}

.card_order.card_message .info {
    height: auto;
    width: 100%;
}

.card_message img {
    width: 65px;
    height: 65px;
    vertical-align: middle;
}

.card_message .info {
    display: inline-block;
    vertical-align: middle;
    width: 170px;
    margin: 0 10px;
    height: 65px;
}

.info .title,
.price {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
}

.info .title {
    font-size: 14px;
    font-weight: 600;
}

.info .desc {
    font-size: 12px;
    color: #666;
    text-align: left;
    height: 34px;

    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.info .price {
    color: #7467f0;
    font-size: 12px;
}

video {
    width: auto;
    max-width: 80%;
}

audio {
    height: 40px;
    outline: none;
}

.el-drawer__wrapper {
    position: absolute;
}

.group_border {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: flex-end;
    padding: 20px 0;
}

.group_item {
    line-height: 25px;
    width: 80%;
    border: 1px solid gainsboro;
    margin: 6px auto;
    cursor: pointer;
    border-radius: 3px;
    padding: 3px 0;
    color: #777777;
}

/*.group_item:hover {*/
/*  color: var(--active-color,'#dc')*/
/*}*/

.group_item:active {
    color: white !important;
}

.el-drawer__body {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.img_border {
    position: fixed;
    width: 100%;
    height: 100%;
}

.img_border img {
    max-width: 85%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: auto;
    bottom: 0;
}

Iframe {
    border: none;
    width: 100%;
}

.goods_message,
.order_message {
    border: 1px solid #e0e0e0;
}

.goods_info {
    display: flex;
}

.goods_info > div,
.order_message > div {
    vertical-align: middle;
}

.goods_image img {
    width: 110px;
    height: 110px;
    display: inline-block;
    overflow: hidden;
    border-radius: 2px;
}

.goods_detail {
    width: 220px;
    height: 110px;
    display: inline-block;
}

.goods_title {
    font-size: 16px;
    font-weight: 600;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    overflow: hidden;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    height: 44px;
    text-align: left;
    padding: 1px 7px;
}

.goods_desc {
    text-align: left;
    line-height: 30px;
    font-size: 14px;
    padding: 0 7px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.goods_label {
    text-align: left;
    line-height: 30px;
    font-size: 16px;
    padding: 0 7px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #7467f0;
}

.goods_action {
    width: 97%;
    text-align: center;
    padding-top: 15px;
    border-top: 1px solid gainsboro;
    margin: 10px auto;
}

.goods_action a {
    text-decoration: none;
    font-size: 14px;
    color: #7467f0;
    display: inline-block;
    width: 100px;
    border: 1px solid #7467f0;
    padding: 5px;
    line-height: 25px;
    border-radius: 20px;
}

.order_data {
    text-align: center;
    line-height: 25px;
    color: #545454;
    font-size: 14px;
    width: 80%;
    margin: 10px auto;
}

.order_data span {
    display: inline-block;
    width: 140px;
    text-align: left;
    color: #7467f0;
}

.largeImage {
    width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/chatpc.vue